// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowListModal-cls1_uup","cls2":"BulkFollowListModal-cls2_gMV BulkFollowListModal-cls1_uup"};